import type { AppRole, OidcUser } from '@/types';
import APP_ROLES from '@/components/AppRoles';

type JwtClaims = {
  roles?: unknown;
};

const toRoleList = (roles_claim: unknown): string[] => {
  if (Array.isArray(roles_claim)) {
    return roles_claim.filter((role): role is string => typeof role === 'string');
  }

  if (typeof roles_claim === 'string') {
    return [roles_claim];
  }

  return [];
};

const decodeJwtClaims = (token: string | undefined): JwtClaims => {
  if (!token) {
    return {};
  }

  const [, payload] = token.split('.');
  if (!payload) {
    return {};
  }

  try {
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded_base64 = base64.padEnd(
      base64.length + ((4 - (base64.length % 4)) % 4),
      '=',
    );

    return JSON.parse(atob(padded_base64)) as JwtClaims;
  } catch {
    return {};
  }
};

const calculateUserRoles = (user: OidcUser | null | undefined): AppRole[] => {
  const azure_roles = [
    ...toRoleList(user?.profile?.roles),
    ...toRoleList(decodeJwtClaims(user?.access_token).roles),
    ...toRoleList(decodeJwtClaims(user?.id_token).roles),
  ];

  if (azure_roles.includes(APP_ROLES.ADMIN_ACCQSURE)) {
    return [APP_ROLES.ADMIN_ACCQSURE];
  }

  if (user?.profile?.['urn:zitadel:iam:org:project:roles']) {
    const groups = Object.keys(
      user?.profile?.['urn:zitadel:iam:org:project:roles'],
    );
    const roles: AppRole[] = [];
    groups.forEach((group) => {
      if (group === 'user') {
        roles.push(APP_ROLES.USER);
      }
      if (group === 'admin') {
        roles.push(APP_ROLES.ADMIN);
      }
      if (group === 'accqsureadmin') {
        roles.push(APP_ROLES.ADMIN_ACCQSURE);
      }
      if (group === 'admin:accqsure') {
        roles.push(APP_ROLES.ADMIN_ACCQSURE);
      }
    });
    return roles;
  }
  return [];
};
export default calculateUserRoles;
